import { type FavoritesMachineGuard, type FavoriteWithId } from '../favorites-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function createFavoritesMachineGuards<Favorite extends FavoriteWithId>() {
  const checkIfCanFetchMoreFavorites: FavoritesMachineGuard<Favorite> = ({ context }) =>
    context.canFetchMoreFavorites;

  return {
    checkIfCanFetchMoreFavorites,
  };
}
